import React from 'react';
import { Scale, Shield, Eye, Power } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SEO } from '../components/SEO';
const ethicsData = [{
  icon: Scale,
  color: 'ai-teal',
  key: 'alignment'
}, {
  icon: Shield,
  color: 'muted-gold',
  key: 'sovereignty'
}, {
  icon: Eye,
  color: 'white',
  key: 'transparency'
}, {
  icon: Power,
  color: 'neural-green',
  key: 'killswitch'
}];
export function EthicsGovernance() {
  const {
    t,
    language
  } = useLanguage();
  const seoTitles = {
    en: 'Ethics & Governance - AI Alignment & Transparency | NEW ASIA TECH',
    id: 'Etika & Tata Kelola - Penyelarasan AI & Transparansi | NEW ASIA TECH'
  };
  const seoDescriptions = {
    en: 'NEW ASIA TECH ethics framework: Alignment Protocol, Data Sovereignty, Algorithmic Transparency, Kill-Switch Architecture. Responsible AI governance for critical systems.',
    id: 'Framework etika NEW ASIA TECH: Protokol Penyelarasan, Kedaulatan Data, Transparansi Algoritmik, Arsitektur Kill-Switch. Tata kelola AI bertanggung jawab untuk sistem kritis.'
  };
  const seoKeywords = {
    en: 'AI ethics, AI governance, algorithmic transparency, data sovereignty, AI alignment, responsible AI, kill switch, AI safety, ethical technology, NEW ASIA TECH ethics',
    id: 'etika AI, tata kelola AI, transparansi algoritmik, kedaulatan data, penyelarasan AI, AI bertanggung jawab, kill switch, keamanan AI, teknologi etis, etika NEW ASIA TECH'
  };
  return <>
      <SEO title={seoTitles[language]} description={seoDescriptions[language]} keywords={seoKeywords[language]} url="/ethics" type="article" data-id="element-294" />

      <div className="min-h-screen pt-32 pb-20 px-6 bg-neural-green/5" data-id="element-295">
        <div className="max-w-[1200px] mx-auto" data-id="element-296">
          <header className="text-center mb-24 animate-fade-in-up" data-id="element-297">
            <h1 className="text-4xl md:text-6xl font-display font-bold text-ivory mb-6" data-id="element-298">
              {t('ethics.title')}
            </h1>
            <p className="text-xl text-muted-gold font-light tracking-wide" data-id="element-299">
              "{t('ethics.quote')}"
            </p>
          </header>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-300">
            {ethicsData.map((item, idx) => {
            const Icon = item.icon;
            return <article key={idx} className={`bg-carbon border border-white/10 p-10 hover:border-white/20 hover:bg-white/[0.02] transition-all duration-500 animate-fade-in-up delay-${idx * 100} group`} data-id="element-301">
                  <div className="mb-6 p-4 bg-white/5 inline-flex rounded-full group-hover:scale-110 transition-transform duration-300" data-id="element-302">
                    <Icon className={`w-8 h-8 text-${item.color}`} data-id="element-303" />
                  </div>
                  <h2 className="text-2xl font-display font-bold text-ivory mb-4 group-hover:text-ai-teal transition-colors" data-id="element-304">
                    {t(`ethics.${item.key}`)}
                  </h2>
                  <p className="text-gray-400 leading-relaxed group-hover:text-gray-300 transition-colors" data-id="element-305">
                    {t(`ethics.${item.key}.desc`)}
                  </p>
                </article>;
          })}
          </div>
        </div>
      </div>
    </>;
}